'use strict';

import controller from './datos-empresa.controller';
import template from './datos-empresa.html';

const DatosEmpresaComponent = {
  bindings: {
    empresa: '='
  },
  controller,
  template
};

export default DatosEmpresaComponent;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/datos-empresa/datos-empresa.component.js